export const popinAdImpression = () => ({
  feature: 'popin_incitation_login_first_visit',
  incitation_type: 'first_visit',
});
